import { Box } from "@mui/material";
import ImportTableWithMap from "../ImportTable/ImportTableWithMap";
import { ImportFormGeoDataProps } from "./ImportForm_GeoData.types";
import { useImportFormGeoDataViewModel } from "./ImportForm_GeoData.vm";
import { WizardContainer } from "./wizard";
import "./ImportForm_GeoData.css";

export function GeoDataImportForm(props: ImportFormGeoDataProps) {
	const vm = useImportFormGeoDataViewModel(props);

	return (
		<div className="geodata-import-form">
			{/* Wizard is the entry point - FileValidation step handles file upload */}
			<WizardContainer
				initialGeoData={vm.initialGeoData}
				initialJobs={vm.wizardJobs}
				onComplete={vm.handleWizardComplete}
				onCancel={vm.handleWizardCancel}
				company={props.selectedCompany ?? undefined}
				allDeals={props.deals}
				salespersons={props.salespersons}
				branches={props.branches}
				selectedBranch={props.selectedBranches?.[0]}
				growers={props.growers}
				user={vm.userContext}
				lastCropOptions={props.lastCropOptions}
				nextCropOptions={props.nextCropOptions}
				renderWithoutDialog={true}
				onStartOver={vm.handleStartOver}
			/>

			{/* Only show ImportTable here when NOT in modal mode - parent handles it in modal mode */}
			{vm.jobData.length > 0 && !props.isInModal && (
				<Box ref={vm.importTableRef} className="import-table-wrapper">
					<ImportTableWithMap
						jobs={vm.jobData}
						updateJobs={(jobs) => {
							vm.setJobData(jobs);
						}}
						deals={props.deals}
						allDeals={props.deals}
						setLoading={(task: string | boolean) => {
							vm.setLoading(!!task);
						}}
						allOptions={{ Boundary: [], Zones: [], Centroids: [], Cores: [], Unknown: [] }}
						resetForm={vm.handleResetForm}
						user={vm.userContext}
						allowMap={true}
						showHeaderSelectors={true}
						headerProperties={vm.extractedHeaderProperties}
						featureStats={vm.featureStats}
						selectedCompany={props.selectedCompany ?? undefined}
						salespersons={props.salespersons ?? []}
						branches={props.branches ?? []}
						lastCropOptions={props.lastCropOptions}
						nextCropOptions={props.nextCropOptions}
					/>
				</Box>
			)}
		</div>
	);
}
